<template>
  <div>
    <ul class="footer">
      <li class="icons">
        <!-- 对接版跳转地址 -->
        <router-link v-if="userDetailInfo.isDock" to="/" @click.native="setIndex(1)">
          <i
            class="iconfont icon-home"
            :style="{ color: modelColor }"
            v-if="selected === 1"
            >&#xe602;</i
          >
          <i class="iconfont icon-home-noActive" v-if="selected != 1">&#xe602;</i>
          <span v-if="selected != 1" style="color: #353535" class="font-home">首页</span>
          <span v-if="selected === 1" class="font-home" :style="{ color: modelColor }"
            >首页</span
          >
        </router-link>
        <!-- 独立版跳转地址 -->
        <router-link v-else to="/" @click.native="setIndex(1)">
          <i
            class="iconfont icon-home"
            :style="{ color: modelColor }"
            v-if="selected === 1"
            >&#xe602;</i
          >
          <i class="iconfont icon-home-noActive" v-if="selected != 1">&#xe602;</i>
          <span v-if="selected != 1" style="color: #353535" class="font-home">首页</span>
          <span v-if="selected === 1" class="font-home" :style="{ color: modelColor }"
            >首页</span
          >
        </router-link>
      </li>
      <li class="icons">
        <!-- 对接版跳转地址 -->
        <router-link
          v-if="userDetailInfo.isDock"
          to="/classify"
          @click.native="setIndex(2)"
        >
          <i
            class="iconfont icon-home"
            :style="{ color: modelColor }"
            v-if="selected === 2"
            >&#xe600;</i
          >
          <i class="iconfont icon-home-noActive" v-if="selected != 2">&#xe600;</i>
          <span v-if="selected != 2" style="color: #353535" class="font-home">分类</span>
          <span v-if="selected === 2" class="font-home" :style="{ color: modelColor }"
            >分类</span
          >
        </router-link>
        <!-- 独立版跳转地址 -->
        <router-link v-else to="/classify" @click.native="setIndex(2)">
          <i
            class="iconfont icon-home"
            :style="{ color: modelColor }"
            v-if="selected === 2"
            >&#xe600;</i
          >
          <i class="iconfont icon-home-noActive" v-if="selected != 2">&#xe600;</i>
          <span v-if="selected != 2" style="color: #353535" class="font-home">分类</span>
          <span v-if="selected === 2" class="font-home" :style="{ color: modelColor }"
            >分类</span
          >
        </router-link>
      </li>
      <li class="icons iconsFound">
        <router-link
          to="/found"
          @click.native="setIndex(3)"
          v-if="sysConfig.decorationType == 2"
        >
          <i
            class="iconfont icon-home"
            :style="{ color: modelColor }"
            v-if="selected === 3"
            >&#xe605;</i
          >
          <i class="iconfont icon-home-noActive" v-if="selected != 3">&#xe605;</i>
          <span v-if="selected != 3" style="color: #353535" class="font-home"
            >常用清单</span
          >
          <span v-if="selected === 3" class="font-home" :style="{ color: modelColor }"
            >常用清单</span
          >
        </router-link>
        <router-link to="/found" @click.native="setIndex(3)" v-else>
          <i
            class="iconfont icon-home"
            :style="{ color: modelColor }"
            v-if="selected === 3"
            >&#xe603;</i
          >
          <i class="iconfont icon-home-noActive" v-if="selected != 3">&#xe603;</i>
          <span v-if="selected != 3" style="color: #353535" class="font-home">发现</span>
          <span v-if="selected === 3" class="font-home" :style="{ color: modelColor }"
            >发现</span
          >
        </router-link>
      </li>
      <li class="icons">
        <div class="bucketNum" :style="{ background: modelColor }">
          {{ bucketNum }}
        </div>
        <!-- 对接版跳转地址 -->
        <router-link
          v-if="userDetailInfo.isDock"
          to="/bucket"
          @click.native="setIndex(4)"
        >
          <i
            class="iconfont icon-home"
            :style="{ color: modelColor }"
            v-if="selected === 4"
            >&#xe601;</i
          >
          <i class="iconfont icon-home-noActive" v-if="selected != 4">&#xe601;</i>
          <span v-if="selected != 4" style="color: #353535" class="font-home"
            >购物车</span
          >
          <span v-if="selected === 4" class="font-home" :style="{ color: modelColor }"
            >购物车</span
          >
        </router-link>
        <!-- 独立版跳转地址 -->
        <router-link v-else to="/bucket" @click.native="setIndex(4)">
          <i
            class="iconfont icon-home"
            :style="{ color: modelColor }"
            v-if="selected === 4"
            >&#xe601;</i
          >
          <i class="iconfont icon-home-noActive" v-if="selected != 4">&#xe601;</i>
          <span v-if="selected != 4" style="color: #353535" class="font-home"
            >购物车</span
          >
          <span v-if="selected === 4" class="font-home" :style="{ color: modelColor }"
            >购物车</span
          >
        </router-link>
      </li>
      <li class="icons">
        <!-- 对接版跳转地址 -->
        <router-link v-if="userDetailInfo.isDock" to="/mine" @click.native="setIndex(5)">
          <i
            class="iconfont icon-home"
            :style="{ color: modelColor }"
            v-if="selected === 5"
            >&#xe602;</i
          >
          <i class="iconfont icon-home-noActive" v-if="selected != 5">&#xe602;</i>
          <span v-if="selected != 5" style="color: #353535" class="font-home">我的</span>
          <span v-if="selected === 5" class="font-home" :style="{ color: modelColor }"
            >我的</span
          >
        </router-link>
        <!-- 独立版跳转地址 -->
        <router-link v-else to="/mine" @click.native="setIndex(5)">
          <i
            class="iconfont icon-home"
            :style="{ color: modelColor }"
            v-if="selected === 5"
            >&#xe602;</i
          >
          <i class="iconfont icon-home-noActive" v-if="selected != 5">&#xe602;</i>
          <span v-if="selected != 5" style="color: #353535" class="font-home">我的</span>
          <span v-if="selected === 5" class="font-home" :style="{ color: modelColor }"
            >我的</span
          >
        </router-link>
      </li>
    </ul>
  </div>
</template>

<script>
import storeMix from "@/mixins/storeMix.js";
export default {
  mixins: [storeMix],
  name: "Index",
  data() {
    return {
      selected: 1,
      //用户详情信息
      userDetailInfo: {},
      bucketNum: 0,
      modelColor: "",
      flag: false,
      userInfoByAppId: {
        companyId: "",
        isDock: "",
        userId: 0,
      },
      isVisitorLookPrice: false, //游客是否可以查看商品价格
      isVisitorLookGoods: false,
      notVisisCustomer: false
    };
  },
  async created() {
    this.flag = true;
    //从cookie中获取用户信息的值
    this.userDetailInfo = await this.$api.common.getUser();
    if (localStorage.getItem("userInfo")) {
      if (this.$api.common.isEmpty(this.userDetailInfo)) {
        this.$cookies.set(
          await this.$api.common.getUserKey(),
          JSON.parse(JSON.stringify(localStorage.getItem("userInfo"))),
          "30d"
        );
        this.userDetailInfo = await this.$api.common.getUser();
      }
    }
    if (this.$api.common.isEmpty(this.userDetailInfo)) {
      this.getCompanyComfigByAppId();
    } else {
      this.getHomePageModuleInfo();
      if (this.userDetailInfo.isDock) {
        //对接版
        this.getBucketNum();
      } else {
        //独立版
        this.getBucketNumAlone();
      }
    }
    // if (this.userDetailInfo.isDock) {
    //   //对接版
    //   this.getBucketNum();
    // } else {
    //   //独立版
    //   this.getBucketNumAlone();
    // }
    this.modelColor = this.$api.common.getModelColor();

    // this.modelColor = this.$api.common.getModelColor();
    // console.log(this.modelColor);
  },
  mounted() {
    this.falg = true;
    // this.isCustomization();
    let that = this;
    this.cons();
    this.util.$on("bucketNum", function (msg) {
      that.getBucketNum();
    });
    //获取购物车数量（新版独立版）
    this.util.$on("bucketNumAlone", function (msg) {
      that.getBucketNumAlone();
    });
    this.modelColor = this.$api.common.getModelColor();
    // this.getHomePageModuleInfo();
  },
  beforeDestroy() {
    this.util.$off('bucketNum')
    this.util.$off('bucketNumAlone')
  },
  methods: {
    //根据appid获取企业信息
    getCompanyComfigByAppId() {
      this.appId = this.$api.common.getAppId()
      // this.appId = "wx7313e84b200f3704";
      let params = {
        appId: this.appId,
      };
      this.$api.homePage.getCompanyComfigByAppId(params).then(async (res) => {
        var result = res.data;
        if (result.status == 200) {
          this.$api.common.setRelation(this.appId,result.data.companyId)
          let isCompanyInfo = new Object();
          isCompanyInfo.companyId = result.data.companyId;
          this.isVisitorLookGoods = result.data.isVisitorLookGoods;
          (isCompanyInfo.isVisitorLookGoods = result.data.isVisitorLookGoods),
            (isCompanyInfo.isVisitorLookPrice = result.data.isVisitorLookPrice),
            (isCompanyInfo.isDock = result.data.isDock);
          isCompanyInfo.userId = result.data.userId;
          this.visitCustomer = isCompanyInfo;
          this.userDetailInfo = this.$api.common.deepCopy(isCompanyInfo);
          this.getHomePageModuleInfo();
          if (this.userDetailInfo.isDock) {
            //对接版
            this.getBucketNum();
          } else {
            //独立版
            this.getBucketNumAlone();
          }
        } else {
          this.isVisitorLookGoods = false;
          localStorage.removeItem("IsCompanyId");
          this.userDetailInfo = await this.$api.common.getUser();
        }
      });
    },
    //定制版游客登录
    // isCustomization() {
    //   if (this.$api.common.isEmpty(this.userDetailInfo)) {
    //     //游客登录
    //     var companyInfoByAppId =
    //       JSON.parse(localStorage.getItem("IsCompanyId")) == null
    //         ? { isVisitorLookGoods: false }
    //         : JSON.parse(localStorage.getItem("IsCompanyId"));
    //     this.isVisitorLookGoods = companyInfoByAppId.isVisitorLookGoods;
    //     if (this.isVisitorLookGoods) {
    //       this.userInfoByAppId.companyId = companyInfoByAppId.companyId;
    //       this.userInfoByAppId.isDock = companyInfoByAppId.isDock;
    //       this.isVisitorLookPrice = companyInfoByAppId.isVisitorLookPrice;
    //       this.userDetailInfo = this.userInfoByAppId;
    //     } else {
    //       this.userDetailInfo = await this.$api.common.getUser();
    //     }
    //   } else {
    //     this.notVisisCustomer = true;
    //   }
    // },
    // 请求首页所有模块信息
    async getHomePageModuleInfo() {
      let params = {
        companyId: this.userDetailInfo.companyId,
        isDock: this.userDetailInfo.isDock,
        storeNo: await this.$api.common.getStoreNo(),
      };
      this.$api.homePage.getHomePageModuleInfo(params).then((res) => {
        let result = res.data;
        if (result.status == 200) {
          result.data.forEach((item) => {
            if (item.moduleType == 10) {
              this.modelColor = item.color;
              this.$api.common.setModelColor(this.modelColor)
            }
          });
        }
      });
    },
    setIndex(index) {
      this.modelColor = this.$api.common.getModelColor();
      this.selected = index;
      // this.getBucketNum();
    },
    cons() {
      // console.log(this.$route.meta.index);
      this.selected = this.$route.meta.index;
    },
    // 购物车数量
    getBucketNum() {
      var params = {
        userId: this.userDetailInfo.userId,
        companyId: this.userDetailInfo.companyId,
        isDock: this.userDetailInfo.isDock,
      };
      this.$api.bucket.getBucketNum(params).then((res) => {
        var result = res.data;
        if (result.status == 200) {
          this.bucketNum = result.data;
        }
      });
    },
    //获取购物车数量（新版独立版）
    getBucketNumAlone() {
      // this.userDetailInfo = await this.$api.common.getUser();
      var params = {
        userId: this.userDetailInfo.userId,
        companyId: this.userDetailInfo.companyId,
      };
      this.$api.bucketAlone.getBucketNumAlone(params).then((res) => {
        var result = res.data;
        if (result.status == 200) {
          this.bucketNum = result.data;
        }
      });
    },
  },
  watch: {
    $route: "cons",
  },
};
</script>

<style lang="scss">
.icon-home {
  padding-top: 6px;
  display: block;
  font-size: 0.64rem;
  color: #ff2d4a;
}
.icon-home-noActive {
  padding-top: 6px;
  display: block;
  font-size: 0.64rem;
  color: #353535;
}
.footer {
  position: fixed;
  z-index: 998;
  width: 100%;
  height: 1.306667rem;
  left: 0;
  bottom: 0;
  // viewport-fit: contain;
  display: flex;
  flex-flow: row nowrap;
  justify-content: space-around;
  background-color: #fff;
  padding-bottom: constant(safe-area-inset-bottom);
  padding-bottom: env(safe-area-inset-bottom);
}
.imgIco {
  width: 0.64rem;
  height: 0.64rem;
}
.icons {
  flex: 1;
  text-align: center;
  position: relative;
  a {
    display: block;
    width: 100%;
    height: 100%;
    text-decoration: none;
    position: relative;
    img {
      display: block;
      width: 0.64rem;
      height: 0.64rem;
      margin: 0 auto;
      padding-top: 0.16rem;
    }
    span {
      text-align: center;
      display: inline-block;
      text-align: center;
      font-size: 13px;
    }
  }
  .bucketNum {
    // position: absolute;
    // background-color: #ff2d4a;
    // color: #fff;
    // right: 0.2rem;
    // top: 0.1rem;
    // width: 0.6rem;
    // height: 0.6rem;
    // border-radius: 50%;
    // text-align: center;
    // line-height: 0.6rem;
    // padding: 0.05rem;
    // z-index: 999;
    // font-size: 12px;
    background-color: #ff2d4a;
    border-radius: 10px;
    color: #fff;
    display: inline-block;
    font-size: 12px;
    height: 18px;
    line-height: 18px;
    padding: 0 6px;
    text-align: center;
    white-space: nowrap;
    border: 1px solid #fff;
    position: absolute;
    top: 0.266667rem;
    right: 0.8rem;
    transform: translateY(-50%) translateX(100%);
  }
}
.iconsFound {
  a {
    img {
      width: 0.906667rem;
    }
  }
}
.font-home {
  margin-bottom: 10px;
  display: inline-block;
  color: #ff2d4a;
}
</style>



// WEBPACK FOOTER //
// src/components/tabbar.vue